import React from 'react'

import Currency from '../../general/Currency'

export interface ICurrencyCell {
  content: number
}

export const CurrencyCell: React.FC<ICurrencyCell> = props => <Currency amount={props.content} />

export default React.memo(CurrencyCell)
